import styled from 'styled-components';
import visitorsBg from '../../assets/images/visitors-bg.png';
import {Button} from 'antd';

export const MainContainer = styled.div`
  padding: 20px;
  width: 85vw;
  overflow-x: auto;
`;

export const NewHeader = styled.div`
  background-color: white;
  padding: 10px;
  width: 100%;
  border-radius: 7px;
  display:flex;
  justify-content : space-between;
  font-size: large;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`;

export const DownloadableCard = styled.div`
  background-image: url(${visitorsBg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 1374px;
  height: 861px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LogoContainer = styled.div`
  position: absolute;
  top: 30px;
  left: 60px;
  z-index: 10;
`;

export const Logo = styled.img`
  height: 100px;
  width: auto;
  object-fit: contain;
`;

export const LogoCover = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #f5f5f5;
  width: 960px;
  height: 400px;
  border-radius: 10px;
  z-index: 1;
`;

export const CardContent = styled.div`
  display: flex;
  gap: 60px;
  padding: 0 10%;
  align-items: center;
  width: 100%;
  position: relative;
  z-index: 2;
`;

export const PhotoContainer = styled.div`
  border: 5px solid #449287;
  border-radius: 25px;
  overflow: hidden;
  width: 280px;
  height: 360px;
  flex-shrink: 0;
  background: #dce6ec;
`;

export const Photo = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const InfoSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: end;
  height: 360px;
`;

export const Title = styled.h2`
  color: #1c4951;
  font-size: 52px;
  font-weight: 800;
`;

export const InfoRow = styled.div`
  display: grid;
  grid-template-columns: 240px auto;
  align-items: baseline;
`;

export const Label = styled.span`
  color: #1a1a1a;
  font-size: 24px;
  font-weight: 600;
`;

export const Value = styled.span`
  color: #1a1a1a;
  font-size: 24px;
  font-weight: 600;
`;

export const BarcodeContainer = styled.div`
  display: flex;
  justify-self: end;
  margin-top: 30px;

  svg {
    max-width: 100%;
  }
`;

export const DownloadButton = styled.button`
  background: #02475C;
  padding: 4px 8px;
  border-radius: 20%;
  cursor: pointer;
  transition: background 0.3s;
  color: #fff;
  border: 1px solid #02475C;
  
  &:hover {
    background: #fff;
    color: #02475C;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 30px;
  padding: 0 20px;
`;

export const TopDiv = styled.div`
  display: flex;
  justify-content: space-between;
  overflow-x: auto;
`;

export const SelectorContainer = styled.div`
  display: flex;
`;

export const Selector = styled.div`
  display: flex;
  flex-direction: column; 
`;

export const DownloadAll = styled(Button)`
  display: flex;
  align-items: center;
  background: #02475C;
  color: #fff;
  border-color: #02475C;
  border-radius: 5px;
  cursor: pointer;

  &:hover{
    background:white;
    color: #02475C;
    border-color: #02475C;
  }
  &:focus {
    background: #02475C;
    color: #fff;
  }

  &:disabled {
    background: #b0c4cc !important;
    color: #ffffff !important;
    cursor: not-allowed;
    opacity: 0.8;
  }
`;
